/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_Unit_LabelInputs */

const en_admin_discounts_unit_label = /** @type {(inputs: Admin_Discounts_Unit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discount Type`)
};

const de_admin_discounts_unit_label = /** @type {(inputs: Admin_Discounts_Unit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rabatt-Typ`)
};

const es_admin_discounts_unit_label = /** @type {(inputs: Admin_Discounts_Unit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de descuento`)
};

const fr_admin_discounts_unit_label = /** @type {(inputs: Admin_Discounts_Unit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de réduction`)
};

/** @type {(inputs: Admin_Discounts_Unit_LabelInputs) => LocalizedString} */
const it_admin_discounts_unit_label = en_admin_discounts_unit_label;

/** @type {(inputs: Admin_Discounts_Unit_LabelInputs) => LocalizedString} */
const pt_br2_admin_discounts_unit_label = en_admin_discounts_unit_label;

/** @type {(inputs: Admin_Discounts_Unit_LabelInputs) => LocalizedString} */
const pl_admin_discounts_unit_label = en_admin_discounts_unit_label;

/** @type {(inputs: Admin_Discounts_Unit_LabelInputs) => LocalizedString} */
const hu_admin_discounts_unit_label = en_admin_discounts_unit_label;

/** @type {(inputs: Admin_Discounts_Unit_LabelInputs) => LocalizedString} */
const ro_admin_discounts_unit_label = en_admin_discounts_unit_label;

/**
* | output |
* | --- |
* | "Discount Type" |
*
* @param {Admin_Discounts_Unit_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_unit_label = /** @type {((inputs?: Admin_Discounts_Unit_LabelInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_Unit_LabelInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_unit_label(inputs)
	if (locale === "de") return de_admin_discounts_unit_label(inputs)
	if (locale === "es") return es_admin_discounts_unit_label(inputs)
	if (locale === "fr") return fr_admin_discounts_unit_label(inputs)
	if (locale === "it") return it_admin_discounts_unit_label(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_unit_label(inputs)
	if (locale === "pl") return pl_admin_discounts_unit_label(inputs)
	if (locale === "hu") return hu_admin_discounts_unit_label(inputs)
	return ro_admin_discounts_unit_label(inputs)
});
export { admin_discounts_unit_label as "admin.discounts.unit_label" }